export default "__VITE_ASSET__BVGkw7Ga__"